import type { BaseController } from '@infra/controllers/base.controller';
import type {
  VoiceMailDropUsecase,
  VoiceMailDropRequest,
} from './voice-mail-drop.usecase';

export type VoiceMailDropInput = {
  call_sid: string;
  prerecorded_message_id: string;
};

export type VoiceMailDropOutput = {
  success: boolean;
};

export class VoiceMailDropController
  implements BaseController<VoiceMailDropInput, VoiceMailDropOutput>
{
  constructor(private usecase: VoiceMailDropUsecase) {}

  async handle(input: VoiceMailDropInput): Promise<VoiceMailDropOutput> {
    const request: VoiceMailDropRequest = {
      call_sid: input.call_sid,
      prerecorded_message_id: input.prerecorded_message_id,
    };

    return this.usecase.run(request);
  }
}
